function configMenu() {

	var menu_aberto;

	$('.menu__trigger').click(function() {
		var $parent = $(this).parent();
		var aberto = $parent.attr('data-aberto');

		if(aberto == 'true') {
			$parent.attr('data-aberto', 'false');
			Cookies.set('sgi_menu_aberto', false, { expires: 30 });
		} else {
			$parent.attr('data-aberto', 'true');
			Cookies.set('sgi_menu_aberto', true, { expires: 30 });
		}
	});

	$('.menu__link').click(function(e) {
		var $parent = $(this).parent();
		var $submenu = $parent.find('ul');
		var aberto = $parent.attr('data-aberto');

		if($submenu.length > 0) {
			if(aberto == 'true') {
				$parent.attr('data-aberto', 'false');
			} else {
				$parent.attr('data-aberto', 'true');
			}

			e.preventDefault();
		}
	});

	function init() {
		menu_aberto = Cookies.get('sgi_menu_aberto');

		if(menu_aberto === undefined) {
			Cookies.set('sgi_menu_aberto', true, { expires: 30 });
		}

		if(menu_aberto == 'true') {
			$('.menu').attr('data-aberto', 'true');
		} else {
			$('.menu').attr('data-aberto', 'false');
		}

		$('.menu__sublink').each(function() {
			if($(this).hasClass('ativo')) {
				$(this).parent().parent().parent().attr('data-aberto', 'true');
			}
		});
	}

	init();

}

export default configMenu;
